import { Navigate } from "react-router";

import { ConnectionFailurePage } from "@/components/Error/ConnectionFailurePage";
import { StartupLoading } from "@/providers/StartupLoading";

import { AuthenticationState, useAuthenticationState } from "./AuthenticationStateProvider";

export function NotLoggedInGuard({ children }: { children: React.ReactNode }): React.ReactNode {
  const state = useAuthenticationState();

  if (state === AuthenticationState.Failed) {
    return <ConnectionFailurePage />;
  }

  if (state === AuthenticationState.Loading) {
    return <StartupLoading />;
  }

  if (state !== AuthenticationState.NotLoggedIn) {
    return <Navigate to="/" />;
  }

  return children;
}
